// <auto-generated />
// ATENCAO: Arquivo auto-gerado pelo SetupController. Nao altere manualmente.

export const PARCEIRO_TIPO = {
  PessoaJuridica: 'PARCEIRO_TIPO1',
  PessoaFisica: 'PARCEIRO_TIPO2',
  Estrangeiro: 'PARCEIRO_TIPO3',
  // Mapa de sequencia (SequenciaLista) para lookup por codigo
  sequencia: {
    PARCEIRO_TIPO1: 1,
    PARCEIRO_TIPO2: 2,
    PARCEIRO_TIPO3: 3
  }
}
